var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.875L8.25 9.375L11.625 6M15 15.75V5.85C15 4.58988 15 3.95982 14.7548 3.47852C14.5391 3.05516 14.1949 2.71095 13.7715 2.49524C13.2901 2.25 12.6601 2.25 11.4 2.25H6.6C5.33988 2.25 4.70982 2.25 4.22852 2.49524C3.80516 2.71095 3.46095 3.05516 3.24524 3.47852C3 3.95982 3 4.58988 3 5.85V15.75L5.0625 14.25L6.9375 15.75L9 14.25L11.0625 15.75L12.9375 14.25L15 15.75Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchases);
export default __webpack_public_path__ + "static/media/purchases.52dcc4dbeff344fa2c3b2188800ef8d3.svg";
export { ForwardRef as ReactComponent };